import dayjs from 'dayjs';

export const fetchBookings = async (
  role: string | null,
  clientResourceId: number | null,
  selectedResource: number | undefined,
  dateRange: { start: string; end: string } | undefined,
  refetch: (resourceId: number | undefined, startDate: string, endDate: string) => Promise<void>
) => {
  try {
    if (!dateRange?.start || !dateRange?.end) return;

    // Format the start and end dates
    const startDate = dayjs(dateRange.start).locale('en').format('YYYY-MM-DDTHH:mm');
    const endDate = dayjs(dateRange.end).locale('en').format('YYYY-MM-DDTHH:mm');

    // Determine the resource ID to fetch based on role and selection
    let resourceId;
    if (role === 'admin') {
      resourceId = selectedResource; // Admin can select a specific resource or leave it undefined
    } else if (role === 'client_admin' || (role === 'client_user' && clientResourceId)) {
      if (!clientResourceId) {
        throw new Error('Client resource ID is not available');
      }
      resourceId = selectedResource ?? clientResourceId; // Use selectedResource if available, otherwise fallback to clientResourceId
    } else {
      throw new Error('Invalid role or resource ID');
    }

    // Fetch bookings using the determined resource ID
    await refetch(resourceId, startDate, endDate);
  } catch (err) {
    // Handle errors gracefully
    if (err instanceof Error) {
      throw new Error('Error fetching bookings: ' + err.message);
    } else {
      throw new Error('Error fetching bookings: An unknown error occurred');
    }
  }
};
